import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/index.vue'
import Photo from '../views/photo.vue'
import Collect from '../views/collect.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/albums',
    name: 'index',
    component: Index,
    meta: {
      title: '时光机-相册',
      icon: 'photo',
    }
  },
  {
    path: '/cllection',
    name: 'collect',
    component: Collect,
    meta: {
      title: '时光机-我的收藏',
      icon: 'collect',
      keepAlive: true
    }
  },
  {
    path: '/myPhoto',
    name: 'photo',
    component: Photo,
    meta: {
      title: '时光机-相片',
      icon: 'pic',
      keepAlive: true
    }
  },
  {
    path: '/album/:album',
    // name: 'album',
    component: () => import('../views/album.vue'),
    meta: {
      title: '时光机-相册',
      keepAlive: true
    }
  },
  {
    path: '/',
    name: 'album',
    component: () => import('../views/album.vue'),
    meta: {
      title: '时光机-相册',
      keepAlive: true
    }
  },
  {
    path: '/:albumId/:id',
    name: 'detail',
    component: () => import('../views/viewDetail.vue'),
    meta: {
      title: '时光机-相片详情'
    }
  },
  {
    path: '/:albumId/:id',
    name: 'group',
    component: () => import('../views/group.vue'),
    meta: {
      title: '时光机-照片组',
    }
  },
  {
    path: '*',
    redirect: '/albums'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
